
import { Component, PropSync, Vue } from 'vue-property-decorator'

@Component({
  filters: {
  },
  components: {
  }
})
export default class TimeEndDialog extends Vue {
  @PropSync('startedAt', { type: Number }) started!: number;
  @PropSync('dialog', { type: Boolean }) timeDialog!: boolean;
  @PropSync('ended', { type: Number }) endTime!: number;

  private time: string | null = null
  private allowedMinutes = (v: any) => v % 15 === 0

  private get min () {
    const startTimeDate = new Date(this.started)
    return startTimeDate.getHours() + ':' + startTimeDate.getMinutes()
  }

  created () {
    if (!this.endTime) return null
    const date = new Date(this.endTime)
    this.time = date.getHours() + ':' + date.getMinutes()
  }
}
